import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Menu from '../Menu';
import 'jquery/dist/jquery.min.js';

// DataTable Modules
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';

import $ from 'jquery';
import axios from 'axios';

const CounsellingPayments = () => {
  const [data, setData] = useState([]);

  const fetchData = () => {
    axios.get('/counselling/dashboard/counselling-payment')
      .then(res => {
        setData(res.data.data.total_student);
        setTimeout(() => {
          $('#example').DataTable({
            destroy: true,
            pagingType: 'full_numbers',
            pageLength: 15,
            processing: true,
            dom: 'Bfrtip',
            buttons: ['copy', 'csv', 'print', 'excelHtml5', 'pdf']
          });
        }, 200);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="container p-5">
          <table id="example" className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>Sl.No</th>
                <th>Student Id</th>
                <th>Student Name</th>
                <th>Mobile No</th>
                <th>Email-ID</th>
                <th>Password</th>
                <th>Program</th>
                <th>Amount</th>
                <th>Payment Status</th>
                <th>Payment Date</th>
              </tr>
            </thead>
            <tbody>
              {data && data.map((result, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{result.user._id}</td>
                  <td>{result.user.name}</td>
                  <td>{result.user.mobileNo}</td>
                  <td>{result.user.email}</td>
                  <td>{result.user.password}</td>
                  <td>{result.user.program}</td>
                  <td>{result.amount}</td>
                  <td>Success</td>
                  <td>{result.payDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CounsellingPayments;
